<template>
    <div class="select-box-wrapper">
        <select v-if="activeFilter === 'artworks'" class="select-box" v-model="filters.artworkModel">
            <option :value="null">{{ artworksLabel }}</option>
            <option
                v-for="artwork in artworks"
                :value="artwork.id"
                >
                {{ artwork.title }}
            </option>
        </select>

        <select v-else class="select-box" v-model="filters.artistModel">
            <option :value="null">{{ artistsLabel }}</option>
            <option
                v-for="artist in artists"
                v-if="artist"
                :value="artist.id"
                >
                {{ artist.title }}
            </option>
        </select>

    </div>
</template>

<script>
export default {
   props: {
        'artworks': { required: true },
        'artists': { required: true },
        'activeFilter': { required: true }
   },
   data: function() {
       return {
           filters: {
                artworkModel: null,
                artistModel: null,
           },
           locale: document.getElementsByTagName('html')[0].getAttribute('lang')
       }
   },
   watch: {
        'filters.artworkModel': function(newVal, oldVal) {
            if(newVal === null) return;
            this.filters.artistModel = null;
        },
        'filters.artistModel': function(newVal, oldVal) {
            if(newVal === null) return;
            this.filters.artworkModel = null;
        }
   },
   methods: {
       resetFilter: function() {
           this.filters.artworkModel = null
           this.filters.artistModel = null
       }
   },
    computed: {
        artistsLabel: function(){
            if(this.locale === 'nl') {
                return 'Alle Kunstenaars';
            }
            return 'All Artists';
        },
        artworksLabel: function(){
            if(this.locale === 'nl') {
                return 'Alle Kunstwerken';
            }
            return 'All Artworks';
        }

    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/site/components/catalog-filter/catalog-select-filter.vue